module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Media/Pause-ed2a8ad364fd8ba9f7acbb2d8d529e49.svg";